import './scss/main.scss'

import { createApp } from 'vue'
import AppPortal from './AppPortal.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import stores from './stores'
import router from './router/portal'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import VueApexCharts from 'vue3-apexcharts'
import pusherPlugin from './plugins/pusher'

const app = createApp(AppPortal)

app.use(stores)
app.use(router)
app.use(i18n)
app.use(pusherPlugin, {
  apiKey: import.meta.env.VITE_PUSHER_KEY || '1e7707caf4d4eca34616',
  cluster: import.meta.env.VITE_PUSHER_CLUSTER || 'ap2',
  authEndpoint: import.meta.env.VITE_PUSHER_AUTH_ENDPOINT || 'https://your-api-endpoint.com/pusher/auth',
})
app.use(createVuestic({ config: vuesticGlobalConfig }))
app.use(VueApexCharts)
app.component('VueDatePicker', VueDatePicker)
app.use(ElementPlus)
app.mount('#app')
